import { Box } from "@mui/material";
import { memo } from "react";
import DynamicIcon from "../../../../UI/DynamicIcon";
import { IDashboardIconProps } from "./models";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import SmartToyRoundedIcon from "@mui/icons-material/SmartToyRounded";

export const DashboardIcon = memo(
  ({ icon, code, grouper }: IDashboardIconProps) => {
    let backgroundIconColor = "#2e7be7";

    switch (grouper) {
      case "SERVICES":
        backgroundIconColor = "#2e7be7";
        break;
      case "MESSAGE":
        backgroundIconColor = "#26cb3d";
        break;
      case "AVERAGE_TIME":
        backgroundIconColor = "#ffb300";
        break;
      case "TIME":
        backgroundIconColor = "#ff000d";
        break;
      default:
        backgroundIconColor = "#2e7be7";
        break;
    }

    return (
      <Box
        sx={(t) => ({
          p: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor:
            code === "12"
              ? t.palette.mode === "light"
                ? t.palette.primary.main
                : t.palette.primary.dark
              : grouper
              ? backgroundIconColor
              : undefined,
          color: code === "12" || grouper ? "#fff" : undefined,
          borderRadius: 1.5,
        })}
      >
        {code === "32" ? (
          <Box
            sx={{
              height: 25,
              width: 40,
              position: "relative",
            }}
          >
            <SmartToyRoundedIcon
              sx={{ position: "absolute", top: 0, left: 0, fontSize: 20 }}
            />
            <SupportAgentRoundedIcon
              sx={{
                position: "absolute",
                bottom: 0,
                right: 0,
                fontSize: 20,
              }}
            />
          </Box>
        ) : (
          <DynamicIcon icon={icon} fontSize={"small"} />
        )}
      </Box>
    );
  }
);
